module.exports = __webpack_public_path__ + "static/media/3-min.7bf0f340.png";